import { IUserRegisterResponse, IUserDocumentResponse, IUserRegisterRequest, IUser } from "../../../models/user/IUser";
import api from "../Api";

const UserApi = () => {

    const register = async (data: IUserRegisterRequest) => {
        const { recaptchaToken, ...body } = data;
        return await api.post<IUserRegisterResponse>(
            '/Account/RegisterWithRecaptcha',
            { ...body, cpf: data.cpf.replace(/[^0-9]/g, "") },
            recaptchaToken ? { headers: { 'g-recaptcha-response': recaptchaToken } } : undefined
        );
    }
    const getEmailByCpf = async (cpf: string) => {

        return await api.post<IUserDocumentResponse>('/SuperApp/User/GetByCpf', { cpf });
    }
    const getUserData = async (): Promise<IUser> => {
        const response = await api.get('/Account/userbasicinfo');
        return response.data
    }
    
    const removeAccount = async () => {
        return await api.put('/Account/Remove');
    }

    return {
        register,
        getEmailByCpf,
        getUserData,
        removeAccount
    }
}
export default UserApi;